import React from "react"
import clsx from "clsx"

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  headingLevel: "banner" | "title" | "subtitle" | "cta" | "card-title"
}

export const Heading: React.FC<HeadingProps> = ({
  headingLevel,
  className,
  children,
  ...props
}) => {
  switch (headingLevel) {
    case "banner":
      return (
        <h1
          className={clsx(
            "font-heading sm:text-title font-semibold sm:leading-[52px]",
            "text-xl leading-[1.5]",
            className
          )}
          {...props}
        >
          {children}
        </h1>
      )
    case "cta":
      return (
        <h3
          className={clsx(
            "font-heading sm:text-title font-semibold sm:leading-[52px]",
            "text-xl leading-[1.5]",
            className
          )}
          {...props}
        >
          {children}
        </h3>
      )
    case "title":
      return (
        <h1
          className={clsx("font-heading sm:text-2xl font-semibold", "text-lg", className)}
          {...props}
        >
          {children}
        </h1>
      )
    case "subtitle":
      return (
        <h2
          className={clsx("font-heading sm:text-lg font-semibold", "text-md ", className)}
          {...props}
        >
          {children}
        </h2>
      )
    case "card-title":
      return (
        <h2 className={clsx("font-heading sm:text-md font-medium", className)} {...props}>
          {children}
        </h2>
      )
    default:
      return (
        <div className={className} {...props}>
          {children}
        </div>
      )
  }
}
